module.exports = __webpack_public_path__ + "img/banner.dd31e87c.jpg";